import Vue from "vue"
import CvPage from './views/cvtool-pages/CvPage.vue'
import JobSearchPage from './views/jobsearch-pages/JobSearchPage.vue'
import GdprExport from '../shared-components/GdprExport.vue'
import SideMenu from '../shared-components/SideMenu.vue'
import PdfViewer from './views/components/PdfViewer.vue'
import JobMatchPage from './views/job-match/JobMatchPage.vue'
import WizardSectionPage from './views/wizard-pages/WizardSectionPage.vue'

// styling
import './styles/main.scss'
// Plugins
import './plugins/bootstrap-vue'// '@app/componentlib/plugins/bootstrap-vue'

export default {
  CvPage,
  JobSearchPage,
  GdprExport,
  SideMenu,
  PdfViewer,
  JobMatchPage,
  WizardSectionPage
}
